import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientAuthenticated, AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import CheckMyLease from '../../q/CheckMyLease';
import CreateFreeLease from '../../q/CreateFreeLease';
import UpdateLease from '../../q/UpdateLease';
import QueryMyLeases from '../../q/QueryMyLeases';
import App from '../../modules/data/App';

function AppView(_props) {
}

AppView.defaultProps = {
};

AppView.propTypes = {
};

export default compose(
  graphql(GetApp, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid,
      },
      client: AppSyncClientUnauthenticated,
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only',
    }),
    // client: AppSyncClientUnauthenticated,
  }),
  graphql(CheckMyLease, {
    props: (props) => ({
      existingLease: props.data.checkMyLease,
    }),
    options: (props) => ({
      variables: {
        uuid: props.match.params.uuid, // This converts 'client.query()' variables into the query parameters
      },
      client: AppSyncClientAuthenticated(props.user),
      // fetchPolicy: 'no-cache',
      fetchPolicy: 'cache-and-network',
      // fetchPolicy: 'network-only',
    }),
    // client: AppSyncClientAuthenticated(),
  }),
  graphql(CreateFreeLease, {
    // name: 'CreateFreeLease',
    props: (props) => ({
      onCreateFreeLease: () => props.mutate({
        variables: {
          uuid: props.ownProps.match.params.uuid,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   existingLease:{...}}
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: CheckMyLease,
        variables: {
          uuid: props.match.params.uuid,
        },
        client: AppSyncClientAuthenticated(props.user),
      }, {
        query: QueryMyLeases,
        client: AppSyncClientAuthenticated(props.user),
      }],
      fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  }),
  graphql(UpdateLease, {
    // name: 'UpdateLease',
    props: (props) => ({
      onUpdateLease: ({ endpointsCompleted, completed }) => props.mutate({
        variables: {
          uuids: `${props.ownProps.user.attributes.sub}-${props.ownProps.match.params.uuid}`,
          endpointsCompleted,
          completed,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   existingLease:{...}}
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: CheckMyLease,
        variables: {
          uuid: props.match.params.uuid,
        },
        client: AppSyncClientAuthenticated(props.user),
      }, {
        query: QueryMyLeases,
        client: AppSyncClientAuthenticated(props.user),
      }],
      fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(AppView);
